import { render, staticRenderFns } from "./thepie.vue?vue&type=template&id=5130d8a4"
import script from "./thepie.vue?vue&type=script&lang=js"
export * from "./thepie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports